import * as React from 'react';

interface OptionsEditorProps {
  value: string[];
  onChange: (options: string[]) => void;
}

export default function OptionsEditor({ value, onChange }: OptionsEditorProps) {
  const [items, setItems] = React.useState<string[]>(value || []);
  const [newItem, setNewItem] = React.useState('');

  React.useEffect(() => { setItems(Array.isArray(value) ? value : []); }, [value]);

  function addItem() {
    const v = newItem.trim();
    if (!v) return;
    if (items.includes(v)) return; // avoid duplicates
    const next = [...items, v];
    setItems(next);
    onChange(next);
    setNewItem('');
  }

  function updateItem(idx: number, val: string) {
    const v = val.trim();
    const next = items.map((it, i) => (i === idx ? v : it)).filter(x => x !== '');
    setItems(next);
    onChange(next);
  }

  function removeItem(idx: number) {
    const next = items.filter((_, i) => i !== idx);
    setItems(next);
    onChange(next);
  }

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 120px', gap:8 }}>
        <input placeholder="Add option" value={newItem} onChange={e=>setNewItem(e.target.value)} className="adm-input" />
        <button type="button" onClick={addItem} className="adm-btn adm-btn-primary">Add</button>
      </div>
      <div>
        {items.length === 0 ? (
          <div style={{ color:'var(--sc-text-subtle)' }}>No options</div>
        ) : (
          <ul style={{ listStyle:'none', padding:0, margin:0 }}>
            {items.map((opt, idx) => (
              <li key={idx} style={{ display:'grid', gridTemplateColumns:'1fr 90px', gap:8, alignItems:'center', marginBottom:6 }}>
                <input value={opt} onChange={e=>updateItem(idx, e.target.value)} className="adm-input" />
                <button type="button" onClick={()=>removeItem(idx)} className="adm-btn adm-btn-danger">Remove</button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
